<template>
    <div class="w-72">
        <input type="text" v-model="query" @input="onInput" @keydown.down.prevent="moveFocus(1)"
            @keydown.up.prevent="moveFocus(-1)" @keydown.enter.prevent="selectFocused" placeholder="Bayi ara..."
            @mouseenter="cancelClose"
            @mouseleave="scheduleClose"
            class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />

        <ArrowPathIcon v-if="isLoading" class="absolute right-2 top-2 w-5 h-5 text-gray-400 animate-spin" />

        <ul v-if="showDropdown"
            @mouseenter="cancelClose"
            @mouseleave="scheduleClose"
            class="fixed z-10 mt-1 w-72 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg max-h-60 overflow-auto">
            <li v-for="(dealer, index) in results" :key="dealer.dealer_id" @click="selectDealer(dealer)" :class="[
                'px-4 py-2 cursor-pointer text-sm',
                index === focusedIndex
                    ? 'bg-indigo-100 dark:bg-indigo-600 text-black dark:text-white'
                    : 'hover:bg-gray-100 dark:hover:bg-gray-700'
            ]">
                {{ dealer.dealer_name }}
            </li>
        </ul>
    </div>
</template>

<script>
import { getApi } from "@/services/api";
import { ArrowPathIcon } from '@heroicons/vue/24/outline';

export default {
    name: "SearchInput",
    components: {
        ArrowPathIcon,
    },
    data() {
        return {
            query: "",
            results: [],
            showDropdown: false,
            focusedIndex: -1,
            timeout: null,
                isLoading: false,
                closeTimer: null
        };
    },
    watch: {
        query(newVal) {
            if (!newVal.trim()) {
                this.clearSearch();
                this.$emit("clear");
            }
        },
    },
    methods: {
        cancelClose() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        },
        scheduleClose() {
            this.cancelClose();
            this.closeTimer = setTimeout(() => {
                this.clearSearch();
            }, 150);
        },
        onInput() {
            clearTimeout(this.timeout);

            if (this.query.trim().length < 3) {
                this.clearSearch();
                return;
            }
            this.timeout = setTimeout(this.fetchDealers, 300);
        },

        async fetchDealers() {
            this.isLoading = true;
            try {
                const res = await getApi(`/dealers/search?q=${encodeURIComponent(this.query)}`);

                this.results = Array.isArray(res) ? res : [];
                this.showDropdown = this.results.length > 0;
                this.focusedIndex = -1;
                // Emit full results so parent can render them in main table
                this.$emit("results", this.results);
            } catch (err) {
                console.error("Bayi arama hatası", err);
                this.clearSearch();
            } finally {
                this.isLoading = false;
            }
        },

        moveFocus(direction) {
            if (!this.results.length) return;
            const total = this.results.length;
            this.focusedIndex = (this.focusedIndex + direction + total) % total;
        },

        selectFocused() {
            if (this.focusedIndex >= 0 && this.focusedIndex < this.results.length) {
                this.selectDealer(this.results[this.focusedIndex]);
            }
        },

        selectDealer(dealer) {
            this.query = dealer.dealer_name;
            this.showDropdown = false;
            this.results = [];
            this.focusedIndex = -1;
            this.$emit("search-select", dealer);
        },

        clearSearch() {
            this.results = [];
            this.showDropdown = false;
            this.focusedIndex = -1;
        },
    },
};
</script>